import { Injectable } from '@angular/core';
import { UseCase } from '@src/core/base/use-case';
import { Observable } from 'rxjs';
import { SucessoSessao } from '@src/data/repository/sessionV3/sessao.entity';
import { SessionRepository } from '@src/core/repositories/sessionV3/session.repository';

@Injectable({
  providedIn: 'root'
})
export class StartUserSessionUsecase implements UseCase<any, SucessoSessao> {
  constructor(private sessionRepository: SessionRepository) { }
  execute(): Observable<SucessoSessao> {
    return this.sessionRepository.startUserSession();
  }
}